import { ICondition, IConditionGroup, IStepWithoutConditionGroups } from '../../interfaces';
import authInfo from '../../services/authInfo';

const VAR_MAPPINGS = {
  first_name: '<my-highlighted>Lyndsey</my-highlighted>',
  full_name: '<my-highlighted>Lyndsey McMahon</my-highlighted>',
  savings: '<my-highlighted>100$</my-highlighted>',
  brand_name: '<my-highlighted>Mr.Cooper</my-highlighted>',
  primary_opportunity: '<my-highlighted>Home</my-highlighted>',
  marketing_opportunity: '<my-highlighted>Policy expiration</my-highlighted>',
  lead_capture_method: '<my-highlighted>Landing page</my-highlighted>',
  attributed_marketing_medium: '<my-highlighted>Email</my-highlighted>',
  lead_create_date: '<my-highlighted>2020-10-10</my-highlighted>',
  prior_policy_expiration_date: '<my-highlighted>2020-10-10</my-highlighted>',
  prior_policy_cost: '<my-highlighted>200$</my-highlighted>',
  prior_policy_carrier: '<my-highlighted>Travelers</my-highlighted>',
  loan_officer_name: '<my-highlighted>Officer Name</my-highlighted>',
  loan_closing_date: '<my-highlighted>2022-10-10</my-highlighted>',
  engagement_experience_type: '<my-highlighted>direct sales</my-highlighted>',
  property_address_state: '<my-highlighted>OH</my-highlighted>',
  property_address: '<my-highlighted>Some street 123, OH</my-highlighted>',
  garaging_address_state: '<my-highlighted>OH</my-highlighted>',
  garaging_address: '<my-highlighted>Some street with garage 123, OH</my-highlighted>'
} as Record<any, any>;

export const transformString = (inputString: string) => {
  if (!VAR_MAPPINGS.user_name) {
    VAR_MAPPINGS.user_name = `<my-highlighted>${authInfo.currentUserName}</my-highlighted>`;
  }
  return inputString.replace(/\{\{([^}]+)\}\}/g, (match, p1) => {
    const mappingValue = VAR_MAPPINGS[p1.trim()];
    return mappingValue !== undefined ? mappingValue : match;
  });
};

const formatCondition = ({ source, operation, value }: ICondition) => `${source} ${operation.toUpperCase()} ${value}`;

export const formatConditionGroups = (groups: IConditionGroup[]) =>
  `${groups.map(group => group.conditions.map(formatCondition).join(' AND ')).join('\n OR\n')}`;

export const sortSteps = (steps: IStepWithoutConditionGroups[] | undefined) => {
  if (!steps) {
    return steps;
  }

  return [...steps].sort((a, b) => (a.name || a.title || '').localeCompare(b.name || b.title || ''));
};
